import { parser as defaultParser } from "./parser.js";
function type(validator, parser = defaultParser()) {
    const getPlainParam = (value) => parser.stringify(value);
    const getTypedParam = (value) => validator(typeof value === "undefined" ? value : parser.parse(value));
    const getPlainSearchParam = (value) => parser.stringify(value);
    const getTypedSearchParam = (value) => validator(typeof value[0] === "undefined" ? value[0] : parser.parse(value[0]));
    const getPlainStateParam = (value) => value;
    const getTypedStateParam = (value) => validator(value);
    return Object.assign({}, // TODO: Remove later. ATM typescript picks the wrong function overload without this.
    {
        getPlainParam,
        getTypedParam: ensureNoError(getTypedParam),
        getPlainSearchParam,
        getTypedSearchParam: ensureNoError(getTypedSearchParam),
        getPlainStateParam,
        getTypedStateParam: ensureNoError(getTypedStateParam),
    }, {
        array: getArrayParamTypeBuilder(ensureNoError(validator), {
            stringify: parser.stringify,
            parse: ensureNoError(parser.parse),
        }),
    }, {
        default: (def) => {
            const validDef = validateDef(validator, def);
            return Object.assign({}, // TODO: Remove later. ATM typescript picks the wrong function overload without this.
            {
                getPlainParam,
                getTypedParam: ensureNoUndefined(ensureNoError(getTypedParam), validDef),
                getPlainSearchParam,
                getTypedSearchParam: ensureNoUndefined(ensureNoError(getTypedSearchParam), validDef),
                getPlainStateParam,
                getTypedStateParam: ensureNoUndefined(ensureNoError(getTypedStateParam), validDef),
            }, {
                array: getArrayParamTypeBuilder(ensureNoUndefined(ensureNoError(validator), validDef), {
                    stringify: parser.stringify,
                    parse: ensureNoUndefined(ensureNoError(parser.parse), validDef),
                }),
            });
        },
        defined: () => {
            return Object.assign({}, // TODO: Remove later. ATM typescript picks the wrong function overload without this.
            {
                getPlainParam,
                getTypedParam: ensureNoUndefined(getTypedParam),
                getPlainSearchParam,
                getTypedSearchParam: ensureNoUndefined(getTypedSearchParam),
                getPlainStateParam,
                getTypedStateParam: ensureNoUndefined(getTypedStateParam),
            }, {
                array: getArrayParamTypeBuilder(ensureNoUndefined(validator), {
                    stringify: parser.stringify,
                    parse: ensureNoUndefined(parser.parse),
                }),
            });
        },
    });
}
const getArrayParamTypeBuilder = (validator, parser) => () => {
    const getPlainSearchParam = (values) => values.map((value) => parser.stringify(value));
    const getTypedSearchParam = (values) => values.map((item) => validator(parser.parse(item)));
    const getPlainStateParam = (values) => values;
    const getTypedStateParam = (values) => (Array.isArray(values) ? values : []).map((item) => validator(item));
    return {
        getPlainSearchParam,
        getTypedSearchParam,
        getPlainStateParam,
        getTypedStateParam,
    };
};
function ensureNoError(fn) {
    return (...args) => {
        try {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return fn(...args);
        }
        catch (error) {
            return undefined;
        }
    };
}
function ensureNoUndefined(fn, def) {
    return (...args) => {
        const result = fn(...args);
        if (result === undefined) {
            if (def === undefined) {
                throw new Error("Unexpected undefined");
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return def;
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return result;
    };
}
function validateDef(validator, def) {
    const validDef = validator(def);
    if (validDef === undefined) {
        throw new Error("Default value validation resulted in 'undefined', which is forbidden");
    }
    return validDef;
}
export { type };
